import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useMutation } from '../components';
import { gql } from '@apollo/client';
import Button from 'jbc-front/components/Button';
import { useNotify } from '@jbc-year-end-adj/common/hooks/useNotify';
import { parse } from 'query-string';
import moment from 'moment';
import { Header } from '../Header';
import styles from './EmployeeStart.scss';

const ROUMU_URL = 'https://id.jobcan.jp/users/sign_in?app_key=lms';
const PAYROLL_URL = 'https://id.jobcan.jp/users/sign_in?app_key=payroll';

const GenerateSecureLink = gql`
  mutation generateSecureLink($input: GenerateSecureLinkInput!) {
    generateSecureLink(input: $input) {
      invaildInterval
    }
  }
`;

const Panel = ({ children }) => <section className={styles.panel}>{children}</section>;

const AnchorPanel = ({ to = '/', children }) => (
  <a target="_blank" rel="noopener noreferrer" href={to} className={styles.anchorPanel}>
    <Panel>{children}</Panel>
  </a>
);

const EmployeeStart = ({ location: { search }, history }) => {
  const [generateSecureLink, { loading }] = useMutation(GenerateSecureLink);
  const notify = useNotify();
  const { token } = parse(search);
  const [invalidUntil, setInvalidUntil] = useState(null);
  const [invalidSeconds, setInvalidSeconds] = useState(0);
  const now = moment();
  const isInvalid = invalidUntil && now.isBefore(invalidUntil);
  useEffect(() => {
    if (isInvalid) {
      const update = () => {
        setInvalidSeconds((invalidUntil.diff(moment()) / 1000) | 0);
      };
      update();
      const intervalId = setInterval(update, 1000);
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [isInvalid, invalidUntil]);
  return (
    <>
      <Header />
      <div className={styles.contents}>
        <AnchorPanel to={ROUMU_URL}>
          <div className={classnames([styles.appBar, styles.roumuColor])}></div>
          <p>ジョブカン労務HRにログインして入力</p>
        </AnchorPanel>
        <AnchorPanel to={PAYROLL_URL}>
          <div className={classnames([styles.appBar, styles.payrollColor])}></div>
          <p>ジョブカン給与計算にログインして入力</p>
        </AnchorPanel>
        <Panel>
          <div className={styles.formPanel}>
            <p className={styles.panelTitle}>ログインせずに入力</p>
            <Button
              primary
              className={styles.submitButton}
              disabled={loading || isInvalid}
              onClick={async () => {
                const {
                  data: {
                    generateSecureLink: { invaildInterval }
                  }
                } = await generateSecureLink({ variables: { input: { token } } });
                setInvalidUntil(moment().add(invaildInterval, 'seconds'));
                notify('送信しました', 'success');
              }}
              widthWide
            >
              入力用URLを送信する{isInvalid && `(${invalidSeconds})`}
            </Button>
            <ul className={styles.note}>
              <li>・入力用URLはメールにてお送りします</li>
              <li>・メールは1分後に再送できるようになります</li>
              <li>・入力用URLの有効期限は30分間です</li>
              <li>・メールアドレスを変更したい場合は管理者にご連絡ください</li>
            </ul>
          </div>
        </Panel>
      </div>
    </>
  );
};
export default EmployeeStart;
